"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const DescriptionFieldTemplate = (props) => {
    const { description, schema } = props;
    if (!description) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement("small", { className: (0, clsx_1.default)(schema.type === 'object' ? 'mb-3' : 'mb-1', 'block text-gray-600 text-sm font-normal') }, description));
};
exports.default = DescriptionFieldTemplate;
